import { fromUnixTime, getUnixTime } from 'date-fns';
import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import {
  Leaderboard,
  LeaderboardOverviewResults,
  LeaderboardResultItem,
} from './_types';

const readOnlyFields = [
  'id',
  'createdAt',
  'updatedAt',
  'thumbnailUrl',
  'imageUrl',
  'newAgeGroup',
];

export const normalizeLeaderboard = (leaderboard: any): Leaderboard => {
  const normalized = camelcaseKeys(leaderboard, { deep: true });
  return {
    ...normalized,
    createdAt: fromUnixTime(normalized.createdAt),
    scoresAvailableOn: normalized.scoresAvailableOn
      ? fromUnixTime(normalized.scoresAvailableOn)
      : null,
  };
};

export const denormalizeLeaderboard = (leaderboard: Partial<Leaderboard>) => {
  removeReadOnlyFields(leaderboard, readOnlyFields);
  const denormalized = decamelizeKeys(leaderboard, {
    deep: true,
  });

  return {
    ...denormalized,
    scores_available_on: denormalized.scores_available_on
      ? getUnixTime(denormalized.scores_available_on)
      : null,
  };
};

export const normalizeLeaderboardList = (data: any) => {
  return {
    ...data,
    leaderboard: data.leaderboard.map(normalizeLeaderboard),
  };
};

export const normalizeResultItem = (item: any): LeaderboardResultItem => {
  return camelcaseKeys(item, { deep: true }) as LeaderboardResultItem;
};

export const normalizeLeaderboardOverviewResults = (
  data: any
): LeaderboardOverviewResults => {
  if (!data) {
    return { all: [], divisions: {} };
  }
  const all = (data.all || []).map(normalizeResultItem);
  const divisions: Record<string, LeaderboardResultItem[]> = {};
  if (data.divisions && typeof data.divisions === 'object') {
    for (const [key, rows] of Object.entries(data.divisions)) {
      divisions[key] = (rows as any[]).map(normalizeResultItem);
    }
  }
  return { all, divisions };
};
